export interface SinclairCompany {
  name: string
  tagline: string
  role: string
  url: string | null
  description: string
  offerings: string[]
  image: string
}

export const companies: SinclairCompany[] = [
  {
    name: 'Sinclair Development',
    tagline: 'Sinclair Develops.',
    role: 'Development, ownership and investment',
    url: null,
    description:
      'Identifying opportunities and bringing together the planning, design, construction and management necessary to turn them into successful properties throughout Southwest Florida.',
    offerings: [
      'Site Development',
      'Commercial Development',
      'Residential Development',
      'Redevelopment',
    ],
    image:
      'https://images.unsplash.com/photo-1486325212027-8081e485255e?w=1400&q=80',
  },
  {
    name: 'Sinclair Custom Homes, Inc.',
    tagline: 'Sinclair Builds.',
    role: 'Construction',
    url: 'https://sinclaircustomhome.com',
    description:
      'Custom residential construction across Southwest Florida, from a single homesite to a full community, built with the same standards we hold on every Sinclair development.',
    offerings: [
      'Custom home construction',
      'Spec and model homes',
      'Luxury residential',
      'Renovations and additions',
    ],
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/ab3196a2-0d15-45b5-aaaa-7927d6b75306.jpg',
  },
  {
    name: 'Sinclair Cabinetry, Inc.',
    tagline: 'Sinclair Crafts.',
    role: 'Cabinetry and millwork',
    url: 'https://sinclaircabinets.com',
    description:
      'Custom cabinetry and finish millwork built in-house, giving our homes and commercial spaces a level of finish that is difficult to source and schedule anywhere else.',
    offerings: [
      'Custom kitchen cabinetry',
      'Bath and closet built-ins',
      'Commercial casework',
      'Finish millwork',
    ],
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/f08cc6a9-bda4-4e6f-b605-edfdfa908012.jpg',
  },
]
